module.exports = ".reporte-seccion {\n  min-height: 150px; }\n\n.reporte-seccion .btn-link {\n  /*override padding btn-link*/\n  padding: 0; }\n\n.reporte-seccion .li {\n  padding: 0.1rem; }\n\n.list-style-none {\n  list-style: none; }\n\n.reporte-seccion .sub-nivel-label {\n  margin-right: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportes/listado/reportes-listado.component.scss
// module id = ./src/app/reportes/listado/reportes-listado.component.scss
// module chunks = main